module.exports = __webpack_public_path__ + "media/Loops 110 Keys.55d25bcc.wav";